<template>
  <section id="machine-learning">
    <div class="co-container-lg px-4 pt-5 text-left md:text-center">
      <h2 class="co-display-9 mb-5 text-center font-bold">
        AI・機械学習・データ分析
      </h2>

      <div class="flex flex-wrap justify-between sm:justify-center">
        <!-- Python -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/python"
        >
          <div class="te-course-title te-bg-python-trans-70 relative flex flex-col justify-center text-center font-bold text-white">
            Python
            <img
              class="te-tag-icon absolute"
              src="~/assets/images/Te/TeCourse/Index/Tag/icon-reskill.svg"
              alt="ReS受講料最大70％支給"
              width="156"
              loading="lazy"
            >
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            AIエンジニアの入り口、機械学習・AIの基礎を習得
          </div>
        </a>

        <!-- AI -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/ai"
        >
          <div class="te-course-title te-bg-ai-trans-70 relative flex flex-col justify-center text-center font-bold text-white">
            AI
            <span class="te-middle-level bg-white p-1 font-normal leading-none text-co-gray-700">中級向け</span>
            <img
              class="te-tag-icon absolute"
              src="~/assets/images/Te/TeCourse/Index/Tag/icon-reskill.svg"
              alt="ReS受講料最大70％支給"
              width="156"
              loading="lazy"
            >
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            Pythonで人工知能(AI)・データ分析の実践
          </div>
        </a>

        <!-- データサイエンス -->
        <a
          class="te-course-block rounded border border-[#dee2e6] bg-white hover:opacity-80"
          href="/course/datascience"
        >
          <div class="te-course-title te-bg-datascience-trans-70 relative flex flex-col justify-center text-center font-bold text-white">
            データサイエンス
            <span class="te-middle-level bg-white p-1 font-normal leading-none text-co-gray-700">中級向け</span>
            <img
              class="te-tag-icon absolute"
              src="~/assets/images/Te/TeCourse/Index/Tag/icon-reskill.svg"
              alt="ReS受講料最大70％支給"
              width="156"
              loading="lazy"
            >
          </div>
          <div class="te-course-caption p-2 text-left text-co-gray-700 md:p-3 lg:p-4">
            Pythonで価格予測やデータ分析機能の開発を実践
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-course-block {
  width: calc(50% - 8px);
  margin-bottom: 20px;
  border-radius: 6px;
  @media (min-width: 576px) {
    width: calc(33% - 16px);
  }
  @media (min-width: 992px) {
    width: calc(25% - 16px);
  }
  &:nth-child(odd) {
    margin-right: 8px;
    @media (min-width: 576px) {
      margin-right: 8px;
      margin-left: 8px;
    }
  }
  &:nth-child(even) {
    margin-left: 8px;
    @media (min-width: 576px) {
      margin-right: 8px;
      margin-left: 8px;
    }
    &:last-child {
      margin: 0 0 20px 8px;
      @media (min-width: 576px) {
        margin: 0 8px 20px;
      }
    }
  }
  &:nth-child(odd):last-child {
    margin: 0 0 20px;
    @media (min-width: 576px) {
      margin: 0 8px 20px;
    }
  }
}

/* コースタイトル */
.te-course-title {
  height: 92px;
  font-size: 0.75rem;
  border-radius: 6px 6px 0 0;
  @media (min-width: 576px) {
    font-size: 0.875rem;
  }
  @media (min-width: 992px) {
    height: 120px;
    font-size: 1.125rem;
  }
}

/* コースアイコン */
.te-course-icon {
  font-size: 1.25rem;
  @media (min-width: 992px) {
    font-size: 1.5rem;
  }
}

.te-tag-icon {
  bottom: -8px;
  left: 50%;
  width: 7.25rem;
  transform: translateX(-50%);
  @media (min-width: 576px) {
    width: 9.75rem;
  }
}

.te-middle-level {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 0.625rem;
  border-radius: 2px;
}

.te-course-caption {
  font-size: 0.75rem;
  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
  @media (min-width: 992px) {
    font-size: 1rem;
  }
}

.te-bg-python-trans-70 {
  background: linear-gradient(
      rgba(62, 123, 175, 0.7) 0%,
      rgba(62, 123, 175, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/Ai/bg-ai.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-ai-trans-70 {
  background: linear-gradient(
      rgba(0, 191, 208, 0.7) 0%,
      rgba(0, 191, 208, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/Ai/bg-ai.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.te-bg-datascience-trans-70 {
  background: linear-gradient(
      rgba(12, 171, 149, 0.7) 0%,
      rgba(12, 171, 149, 0.7) 100%
    ),
    url('~/assets/images/Te/TeCourse/Index/Ai/bg-ai.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>

